import axios from "axios";
import { sendEmail } from "./emailjs";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

/**
 * Submit quote request - sends via EmailJS only
 */
export const submitQuote = async (data) => {
  return await sendEmail("quote", data);
};

/**
 * Submit contact form - sends via EmailJS only
 */
export const submitContact = async (data) => {
  return await sendEmail("contact", data);
};

/**
 * Subscribe to newsletter - sends via EmailJS only
 */
export const subscribeNewsletter = async (email) => {
  return await sendEmail("newsletter", { email });
};

/**
 * Submit custom packaging request - sends via EmailJS only
 */
export const submitCustomPackaging = async (data) => {
  return await sendEmail("custom", data);
};

// Admin functions (still use API)
export const getQuotes = () => api.get("/admin/quotes").then((r) => r.data);
export const getContacts = () => api.get("/admin/contacts").then((r) => r.data);
